import React from 'react'
import ReactDOM from 'react-dom'
import { initServerFromLocalStorage } from 'src/services/initServer'

import App from './pages/App'
initServerFromLocalStorage()
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
